import * as types from "./mutation-types"

export default {
  [types.RESET_SECTION_INDICES](state, payload) {
    state.sectionIndices = payload
  },

  [types.CHANGE_SECTION_INDEX](state, payload) {
    state.sectionIndices[payload.pageIndex] = payload.sectionIndex
  },

  [types.UPDATE_PAGE_SCALE](state, payload) {
    state.pageScale = payload.pageScale
  },

  [types.UPDATE_VIDEO_URL](state, payload) {
    state.videoURL = payload
  },

  [types.UPDATE_AUDIO_URL](state, payload) {
    state.audioURL = payload
  },

  [types.UPDATE_IS_FRONT_PAGE](state, payload) {
    console.log(payload)
    if (payload){
      state.document.width = 1448
      console.log(state.document.width)
    } else {
      state.document.width = 724
      console.log(state.document.width)
    }
    
  },

  [types.TOGGLE_LANGUAGES](state) {
    if (state.activePanel == "Languages") {
      state.activePanel = ""
    } else {
      state.activePanel = "Languages"
    }
  },

  [types.TOGGLE_EDITIONS](state) {
    if (state.activePanel == "Editions") {
      state.activePanel = ""
    } else {
      state.activePanel = "Editions"
    }
  },

  [types.TOGGLE_CONTENTS](state) {
    if (state.activePanel == "Contents") {
      state.activePanel = ""
    } else {
      state.activePanel = "Contents"
    }
  },

  [types.TOGGLE_SEARCH](state) {
    if (state.activePanel == "Search") {
      state.activePanel = ""
    } else {
      state.activePanel = "Search"
    }
  },

  [types.TOGGLE_GUIDE](state) {
    if (state.activePanel == "Guide") {
      state.activePanel = ""
    } else {
      state.activePanel = "Guide"
    }
  },

  [types.TOGGLE_ZOOM](state, payload = null) {
    // console.log('toggleZoom', payload.zoomOriginX)
    if (state.zoomLevel != 1) {
      state.zoomLevel = 1
      state.zoomOriginX = 0
      state.zoomOriginY = 0
    } else {
      state.zoomLevel = payload.zoomLevel || 2
      state.zoomOriginX = payload.zoomOriginX || 0
      state.zoomOriginY = payload.zoomOriginY || 0
    }
    console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX)
  },

  [types.UPDATE_ZOOM](state, payload) {
    state.zoomOriginX = payload.zoomOriginX
    state.zoomOriginY = payload.zoomOriginY
    state.zoomLevel = payload.zoomLevel || 2
    // console.log('update zoom', payload)
    console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX)
    if (state.zoomLevel < 1) {
      state.zoomLevel = 1
      console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX)
    }
  },

  [types.UPDATE_INITIAL_WINDOW_SIZE](state, payload) {
    state.initialPageWidth = payload.width
    state.initialPageHeight = payload.height
  },

  [types.UPDATE_IS_DOUBLE_PAGE](state, payload) {
    state.isDoublePage = payload
  },

  [types.UPDATE_GALLERY](state, payload) {
    state.galleryImages = payload
  },

  [types.UPDATE_GALLERY_INDEX](state, payload) {
    state.galleryIndex = payload
  },

  [types.TOGGLE_READER](state, payload) {
    state.isReader = !state.isReader
  },

  [types.OPEN_ARTICLE] (state, payload) {
    state.isArticle = true
    state.articleIndex = payload
    // document.getElementsByClassName('article-content')[0].scrollIntoView(true)
  },

  [types.CLOSE_ARTICLE] (state, payload) {
      state.isArticle = false
  },

  [types.INCREASE_ARTICLE_FONT_SIZE] (state, payload) {
    var x = document.getElementById('article-container')
    x.style.fontSize = state.articleFontSize.toString() + "em"
    if(state.articleFontSize < 1.6) {
      state.articleFontSize += .2
    }
    x.style.fontSize = state.articleFontSize.toString() + "em"
  },

  [types.DECREASE_ARTICLE_FONT_SIZE] (state, payload) {
    var x = document.getElementById('article-container')
    x.style.fontSize = state.articleFontSize.toString() + "em"
    if(state.articleFontSize > 1) {
      state.articleFontSize -= .2
    }
    x.style.fontSize = state.articleFontSize.toString() + "em"
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js